<table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">
    
  <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="label">Label</th>
      <td mat-cell *matCellDef="let element" > {{element.label || '-'}} </td>
  </ng-container>

  <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="country">Pays</th>
      <td mat-cell *matCellDef="let element" >{{element.country || '-'}} </td>
  </ng-container>

  <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="region">Région </th>
      <td mat-cell *matCellDef="let element" > {{element.region || '-'}} </td>
  </ng-container>

  <ng-container matColumnDef="department">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="department">Dép. </th>
    <td mat-cell *matCellDef="let element" > {{element.department || '-'}} </td>
</ng-container>

  <ng-container matColumnDef="postalCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="postalCode">CP </th>
      <td mat-cell *matCellDef="let element" > {{element.postalCode || '-'}} </td>
  </ng-container>
  <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="city">Ville </th>
      <td mat-cell *matCellDef="let element" > {{element.city || '-'}} </td>
  </ng-container>
  <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="address" >Adresse </th>
      <td mat-cell *matCellDef="let element" > {{element.box}}<span *ngIf="element.box">,</span> {{element.address || '-'}}  </td>
  </ng-container>

  <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef id="header_cell_update_practice_place_solo" class="cell_action"> Editer </th>
      <td mat-cell *matCellDef="let element" [id]="getId(element, 'th')"  class="cell_action">
          <fa-icon [icon]="getFaIcon('faPen')"  (click)="goEdit('edit', element)"  appChangeColorTheme attribute="color"></fa-icon>
      </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;">
  </tr>
</table>

<div class="no_practice_place" *ngIf="!dataSource?.filteredData.length">
    Aucun lieu de pratique 
</div>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  (page)="pageEvent = $event" [color]="color">
</mat-paginator>